/**
 * Objectifs (décision du propriétaire du 15 octobre 2026) : une tâche avec une
 * heure limite. Libellés et couleurs d'état partagés par la page Tâches, le
 * planning et l'accueil — lus de la même façon partout, sans mot de sanction.
 */
import { objectiveState, type ObjectiveState } from '@myequip/shared';

export { objectiveState, type ObjectiveState };

export const OBJECTIVE_STATE_LABELS: Record<ObjectiveState, string> = {
  en_cours: 'À faire',
  bloque: 'Bloqué',
  tenu: 'Tenu',
  fait_apres: 'Fait après l’heure',
  non_atteint: 'Non atteint',
};

/** Ton de pastille (`badge--…`) de chaque état. */
export const OBJECTIVE_STATE_TONES: Record<ObjectiveState, string> = {
  en_cours: 'badge--info',
  bloque: 'badge--warn',
  tenu: 'badge--ok',
  fait_apres: 'badge--ok',
  non_atteint: 'badge--danger',
};

/** Une ligne d'aide, la même dans le formulaire et dans l'aide du planning. */
export const OBJECTIVE_HINT =
  'Un objectif clair à une heure précise aide à avancer sans être derrière : la personne sait quoi finir, pour quand, et peut dire qu’elle bloque.';

/**
 * Créer un objectif dont l'heure limite est déjà choisie (« AAAA-MM-JJThh:mm »,
 * heure locale) : la page de création, sous les noms communs `type`, `date`, `heure`.
 */
export function newObjectivePath(deadline: string): string {
  const [date, heure] = deadline.split('T');
  return `/taches/nouvelle?type=objectif&date=${date}&heure=${encodeURIComponent((heure ?? '').slice(0, 5))}`;
}

function sameDay(a: Date, b: Date): boolean {
  return a.toDateString() === b.toDateString();
}

/** « 12:00 » aujourd'hui, « demain 12:00 », sinon « jeu. 16 oct. 12:00 ». */
export function deadlineText(iso: string, now = new Date()): string {
  const due = new Date(iso);
  const time = due.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' });
  if (sameDay(due, now)) return time;
  const tomorrow = new Date(now);
  tomorrow.setDate(tomorrow.getDate() + 1);
  if (sameDay(due, tomorrow)) return `demain ${time}`;
  return `${due.toLocaleDateString('fr-FR', { weekday: 'short', day: 'numeric', month: 'short' })} ${time}`;
}
